import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getUpdatePasswordErrorMessage } from '../selectors/ErrorSelector';
import { getChangePasswordModalOpen } from '../selectors/InteractionSelector';
import { getUpdatePasswordRequestStatus } from '../selectors/RequestStatusSelector';
import ChangePasswordModal from '../components/ChangePasswordModal';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Patt... Remove this comment to see the full error message
import PasswordPattern from 'PatternValidationJS/patterns/Password';
import { updatePassword } from '../actions/ProfileActions';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import { toggleChangePasswordModalOpen, toggleForgotPasswordModalOpen } from '../actions/AppActions';
import { trackScreen } from '../lib/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
const INVALID_CURRENT_PASSWORD_ERROR = 'Provided current password is incorrect!';
const LEAKED_NEW_PASSWORD = 'Password has been found in a list of leaked passwords';
class ChangePasswordModalContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stagedCurrentPassword: '',
      stagedCurrentPasswordValidationMessage: undefined,
      stagedNewPassword: '',
      stagedNewPasswordValidationMessage: undefined,
      stagedNewPasswordVisible: false,
      leakedPassword: false
    };
    this.onToggleNewPasswordVisible = this.onToggleNewPasswordVisible.bind(this);
    this.onStagedCurrentPasswordChanged = this.onStagedCurrentPasswordChanged.bind(this);
    this.onStagedNewPasswordChanged = this.onStagedNewPasswordChanged.bind(this);
    this.onUpdatePassword = this.onUpdatePassword.bind(this);
    this.onForgotPassword = this.onForgotPassword.bind(this);
    this.resetStateAndCloseModal = this.resetStateAndCloseModal.bind(this);
  }
  componentDidUpdate(prevProps) {
    const {
      updatePasswordRequestStatus,
      changePasswordModalOpen,
      updatePasswordErrorMessage
    } = prevProps;
    if (this.props.updatePasswordErrorMessage && this.props.updatePasswordErrorMessage !== updatePasswordErrorMessage) {
      const errorMessage = this.props.updatePasswordErrorMessage;
      if (errorMessage.indexOf(INVALID_CURRENT_PASSWORD_ERROR) !== -1) {
        this.setState({
          stagedCurrentPasswordValidationMessage: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.errors.incorrectPassword"
          })
        });
      } else if (errorMessage.indexOf(LEAKED_NEW_PASSWORD) !== -1) {
        this.setState({
          leakedPassword: true,
          stagedNewPasswordValidationMessage: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.errors.leakedPassword.title"
          })
        });
      } else {
        this.setState({
          stagedCurrentPasswordValidationMessage: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.errors.renderError"
          })
        });
      }
    } else if (updatePasswordRequestStatus === RequestStatusTypes.PENDING && this.props.updatePasswordRequestStatus === RequestStatusTypes.SUCCEEDED) {
      this.resetStateAndCloseModal();
    }
    if (this.props.changePasswordModalOpen && !changePasswordModalOpen) {
      trackScreen('change-password-modal');
    }
  }
  onToggleNewPasswordVisible() {
    const {
      stagedNewPasswordVisible
    } = this.state;
    this.setState({
      stagedNewPasswordVisible: !stagedNewPasswordVisible
    });
  }
  onStagedCurrentPasswordChanged(password) {
    this.setState({
      stagedCurrentPassword: password,
      stagedCurrentPasswordValidationMessage: undefined
    });
  }
  onStagedNewPasswordChanged(password) {
    this.setState({
      stagedNewPassword: password,
      stagedNewPasswordValidationMessage: undefined,
      leakedPassword: false
    });
  }
  getAbleToUpdatePassword() {
    const {
      stagedCurrentPassword,
      stagedNewPassword,
      stagedCurrentPasswordValidationMessage,
      stagedNewPasswordValidationMessage
    } = this.state;
    return stagedCurrentPassword.length && stagedNewPassword.length && !stagedCurrentPasswordValidationMessage && PasswordPattern.test(stagedNewPassword) && !stagedCurrentPasswordValidationMessage && !stagedNewPasswordValidationMessage;
  }
  onUpdatePassword() {
    const {
      stagedCurrentPassword,
      stagedNewPassword
    } = this.state;
    this.props.updatePassword(stagedCurrentPassword, stagedNewPassword);
    this.setState({
      stagedCurrentPasswordValidationMessage: undefined,
      leakedPassword: false
    });
  }
  onForgotPassword() {
    this.resetStateAndCloseModal();
    this.props.toggleForgotPasswordModalOpen();
  }
  resetStateAndCloseModal() {
    this.setState({
      stagedCurrentPassword: '',
      stagedCurrentPasswordValidationMessage: undefined,
      stagedNewPassword: '',
      stagedNewPasswordValidationMessage: undefined,
      stagedNewPasswordVisible: false,
      leakedPassword: false
    });
    this.props.toggleChangePasswordModalOpen();
  }
  render() {
    const {
      changePasswordModalOpen
    } = this.props;
    const {
      stagedCurrentPassword,
      stagedCurrentPasswordValidationMessage,
      stagedNewPassword,
      stagedNewPasswordValidationMessage,
      stagedNewPasswordVisible,
      leakedPassword
    } = this.state;
    if (changePasswordModalOpen) {
      return /*#__PURE__*/_jsx(ChangePasswordModal, {
        stagedCurrentPassword: stagedCurrentPassword,
        stagedCurrentPasswordValidationMessage: stagedCurrentPasswordValidationMessage,
        stagedNewPassword: stagedNewPassword,
        stagedNewPasswordValidationMessage: stagedNewPasswordValidationMessage,
        stagedNewPasswordVisible: stagedNewPasswordVisible,
        leakedPassword: leakedPassword,
        updatePasswordButtonDisabled: !this.getAbleToUpdatePassword(),
        onStagedCurrentPasswordChanged: this.onStagedCurrentPasswordChanged,
        onStagedNewPasswordChanged: this.onStagedNewPasswordChanged,
        toggleNewPasswordVisible: this.onToggleNewPasswordVisible,
        onUpdatePassword: this.onUpdatePassword,
        onCloseModal: this.resetStateAndCloseModal,
        onForgotPassword: this.onForgotPassword
      });
    }
    return null;
  }
}
ChangePasswordModalContainer.propTypes = {
  changePasswordModalOpen: PropTypes.bool.isRequired,
  updatePasswordRequestStatus: PropTypes.string.isRequired,
  toggleChangePasswordModalOpen: PropTypes.func.isRequired,
  toggleForgotPasswordModalOpen: PropTypes.func.isRequired,
  updatePassword: PropTypes.func.isRequired,
  updatePasswordErrorMessage: PropTypes.string
};
const mapStateToProps = state => {
  return {
    changePasswordModalOpen: getChangePasswordModalOpen(state),
    updatePasswordRequestStatus: getUpdatePasswordRequestStatus(state),
    updatePasswordErrorMessage: getUpdatePasswordErrorMessage(state)
  };
};
export default connect(mapStateToProps, {
  updatePassword,
  toggleChangePasswordModalOpen,
  toggleForgotPasswordModalOpen
})(ChangePasswordModalContainer);